export default __webpack_public_path__ + "static/media/business-overview.eb62325b.png";